import { render, staticRenderFns } from "./Weddings.vue?vue&type=template&id=bfbbc9ea&scoped=true"
import script from "./Weddings.vue?vue&type=script&lang=js"
export * from "./Weddings.vue?vue&type=script&lang=js"
import style0 from "./Weddings.vue?vue&type=style&index=0&id=bfbbc9ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbbc9ea",
  null
  
)

export default component.exports